// ============================================================================
// Widget — SLA / TAT Breaches
// Top 5 cases breaching their stage TAT. Compact table, no chart.
// ============================================================================
import React from 'react';
import WidgetShell from './WidgetShell';
import { mockSlaBreaches, fmtAmount } from '../executiveMockData';

const SlaBreachWidget: React.FC = () => (
  <WidgetShell
    title="SLA / TAT Breaches"
    subtitle="Top 5 cases overdue against their stage TAT"
  >
    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.78rem' }}>
      <thead>
        <tr style={{ background: '#dbeafe' }}>
          <th style={th}>Case #</th>
          <th style={th}>Type / Stage</th>
          <th style={th}>Branch</th>
          <th style={{ ...th, textAlign: 'right' }}>Days / TAT</th>
          <th style={{ ...th, textAlign: 'right' }}>OS</th>
        </tr>
      </thead>
      <tbody>
        {mockSlaBreaches.map(b => {
          const overrun = b.daysInStage - b.tatDays;
          const intensity = Math.min(1, overrun / b.tatDays); // 0..1
          const cellBg = `rgba(220, 38, 38, ${0.06 + intensity * 0.18})`;
          return (
            <tr key={b.caseCode} style={{ borderTop: '1px solid var(--border-color)' }}>
              <td style={td}><strong>{b.caseCode}</strong></td>
              <td style={td}>
                <div>{b.caseType}</div>
                <div style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>{b.stage}</div>
              </td>
              <td style={td}>{b.branch}</td>
              <td style={{ ...td, textAlign: 'right', background: cellBg, fontVariantNumeric: 'tabular-nums' }}>
                <strong style={{ color: '#b91c1c' }}>{b.daysInStage}</strong>
                <span style={{ color: 'var(--text-secondary)' }}> / {b.tatDays}</span>
              </td>
              <td style={{ ...td, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>{fmtAmount(b.outstanding)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </WidgetShell>
);

const th: React.CSSProperties = {
  textAlign: 'left', padding: '0.45rem 0.55rem', fontWeight: 600,
  color: 'var(--text-secondary)', borderBottom: '2px solid var(--border-color)',
  fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.04em',
};
const td: React.CSSProperties = { padding: '0.5rem 0.55rem', verticalAlign: 'top' };

export default SlaBreachWidget;
